import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-condition-info-dialog',
    templateUrl: './condition-info-dialog.component.html',
    styleUrls: ['./condition-info-dialog.component.scss'],
    standalone: false
})
export class ConditionInfoDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConditionInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private localStorageSettings:LocalStorageSettingsService,private snackbar: MatSnackBar,
  ) { }

     
   /** 
    * Implemented by Renuka chama
    * 16/10/2025
    * code implemented to add view condition popup. */

  backgroundColorButton = "";
  tempFilters: any[] = [];

  ngOnInit(): void {
     this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
     this.tempFilters = JSON.parse(JSON.stringify(this.data.filters || []));
  }
   removeCondition(index: number): void {
    this.tempFilters.splice(index, 1);
  }

  update(): void {
    if (this.tempFilters.length == 0) {
      this.snackbar.open('At least one condition is required.', 'OK', { duration: 4000 });
      return;
    }
    this.data.filters = JSON.parse(JSON.stringify(this.tempFilters));
    
    this.dialogRef.close(this.data);
  }

  close(){
    this.dialogRef.close();
  }
}
